import { OpenLinkOptions } from "./open-link-options"

export default async function openLink(url: string, options: OpenLinkOptions = {}) {
  if (options.dialogTab) {
    const parsedUrl = new URL(window.location.href)
    parsedUrl.searchParams.set('dialogOpen', 'true')

    if (options.queryParams) {
      Object.entries(options.queryParams).forEach(([key, value]) => {
        parsedUrl.searchParams.set(key, value)
      })
    }

    window.open(parsedUrl.toString(), '_blank')
    window.location.href = url
  } else {
    window.open(url, '_blank')
  }
}
